import { render, staticRenderFns } from "./VideoInfoHorizontal.vue?vue&type=template&id=46de9a2d&scoped=true"
import script from "./VideoInfoHorizontal.vue?vue&type=script&lang=js"
export * from "./VideoInfoHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46de9a2d",
  null
  
)

/* custom blocks */
import block0 from "./VideoInfoHorizontal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports